export default __webpack_public_path__ + "1420bceb27d3aadc82a7d7588fa28e85.png";